import './download.style.sass';
import template from './download.tpl.pug';

class DownloadController {
    /* @ngInject */
    constructor($window) {
        this.$window = $window;
        this.platforms = [
            {
                id: 'web',
                name: 'Web App',
                description: 'Use Dollarbird in your browser',
                icon: 'desktop',
                url: 'http://app.localhost:3000'
            },
            {
                id: 'ios',
                name: 'iOS App',
                description: 'Download from the App Store',
                icon: 'apple',
                url: 'https://get.dev.dollarbird.co/ios'
            },
            {
                id: 'android',
                name: 'Android App',
                description: 'Get it on Google Play',
                icon: 'android',
                url: 'https://get.dev.dollarbird.co/android'
            }
        ];
    }

    downloadApp(platform) {
        this.onSubmit({
            questionKey: 'download_platform',
            answer: platform.id
        });
        this.$window.location.href = platform.url;
    }
}

export default {
    template: template(),
    controller: DownloadController,
    bindings: {
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/download/download.cmpt.js